// From scratch, rewrite of purchase.js.liquid (by Mobikasa)
// Trint Ladd - Alt-N
// Created 2021-02-11
// Modified:
// 2021-03-30 - Mobikasa
// Mobikasa re-wrote the second AJAX call in addToCart to fix mystery bug.
// Removed time delay on cart redirect. - TL, 2021-04-27
// Switched to shop.mdaemon.com for API calls. - TL, 2021-05-20
// Added token security to ajax. - TL, 2021-06-30
// Added line item description from GetUnitPrice API. - TL, 2021-08-19
// Refactoed GetUnitPrice arguments to an array to support API changes. - TL, 2021-10-4
// 2022-2-2 Added FinalQty for use in CustomVariants to get Shofiy/QuickBooks SKU. - TL
// 2022-3-23 Reworked to remove MA bundles. - TL
// 2022-05-17 Added License Notes. - TL
// 2022-6-24 Added SA purchase. - TL
// 2022-07-13 Added MS purchase. - TL
// 2022-11-? Removed MS checkout. Not ready for rushed go-live - TL
// 2022-11-16 Various bug fixes. Mostly for enable/disable next. - TL
// 2023-5-1 Change how m_skyType is set. radio list's .val() is hard to set. - TL
// 2024-2-5 FIX: Mailstore max is 500. This has to be explicit for NEW (without key lookup). - TL
// 2024-3-8 FIX: Per Kevin, Mailstore changed their max from 500 to 2000. - TL
// 2024-6-25 FIX: MailStore EXP does not allow term > 1 year. Also simplify logic to enable next buttons. - TL
// 2025-07-10 Removed some debugging. - TL
// 2025-11-21 Changed order of operations in lookupKey() to fix button enable/disable errors. - TL

// Globals *********************************************************************
let m_mainProductCode = "";
let m_mainProductID = "";
let m_mainID = -1;
let m_mainDescription = "";
let m_mainQty = -1;
let m_mainQtyMin = 5;
let m_mainQtyMax = 2500;
let m_mainLicenseNote = "";
let m_mainSku = "";
let m_mainDuration = -1;
let m_skuType = "";
let m_userID = "";
let m_token = "";

let m_PrioritySupport = false;
let m_oldKey = "";
let m_oldQty = -1;
let m_oldEndDate = "";
let m_oldSAEndDate = "";
let m_oldSAExpired = false;

let m_mainListPrice = 0;
let m_mainDiscountPrice = 0;
let m_SAPrice = 0
let m_SADescription = "";
let m_totalPrice = 0;
let m_IsFeature = false;

let m_currentStep = 1;
let m_allProductsArray = [];
let m_dirty = true;
let m_lastCallData = null;

$( document ).ready( function()
{
	// Set global defaults *********************************************************
	m_mainProductCode = $( '.section-purchase' ).attr( 'data-productcode' );
	m_mainProductID = parseFloat( $( '.section-purchase' ).data( 'product-id' ) );
	m_mainID = parseFloat( $( '.section-purchase' ).data( 'product-id' ) );
	m_userID = $( '.section-purchase' ).data( 'customer-id' );

	if( m_mainProductCode == "MS" )
	{
		m_mainQtyMax = 2000;
	}
	if( $( '[name="licenseTerm"]' ).length == 0 )
	{
		// Duration selector does not appear for this product.
		m_mainDuration = 1;
	}
	var passedKey = getQueryStringValue( "regKey" );
	if( passedKey != null )
	{
		// RegKey passed in query string. Assume renewal.
		$( '#purchaseRenew' ).trigger( 'click' );

		$( '.input-product-key' ).val( passedKey );
		m_oldKey = passedKey;
		// After token is received, call lookupKey();
	}
	m_skuType = $( 'input[name = "licenseType"]:checked' ).val();
	licenseTypeChanged();

	let requestData = {
		objectId: m_mainProductID,
		userId: m_userID,
		path: window.location.href
	};
	$.ajax( {
		url: 'https://shop.mdaemon.com/Product/GetToken',
		method: 'POST', type: 'POST',
		data: JSON.stringify( requestData ),
		dataType: 'json',
		contentType: 'application/json',
		crossDomain: true,
		success: function( result )
		{
			if( result != null && result.Token != null )
			{
				m_token = result.Token;
				if( m_oldKey.length > 0 )
				{
					// Key was prepopulated. Look it up.
					lookupKey();
				}
			}
			else
			{
				console.log( "Bad token result." ); // DEBUG
			}
		}
	} );

	$( window ).load( function()
	{
		// Done loading so...
		$( '.purchase-wizard' ).removeClass( 'preloading' );
	} );

	// Events **********************************************************************

	// Step/Styling events *************************

	// Set step on click.
	// Top links have .step .btn-step .step-prev step-current .active and data-step="#"
	// Buttons have .btn-form .btn-step btn-next/prev and data-step="#"
	$( document ).on( 'click', '.btn-step', function()
	{
		let ele = $( this )
		m_currentStep = parseFloat( ele.data( 'step' ) );
		// Hide all steps.
		$( '.purchase-details-info[data-step]' ).hide();
		$( '.step[data-step]' ).removeClass( 'step-current active' );
		// Show new step.
		$( '.purchase-details-info[data-step="' + m_currentStep + '"]' ).show();
		$( '.step[data-step="' + m_currentStep + '"]' ).addClass( 'step-current' );

		// This is for styling of the top links.
		$( '.step-current' ).prevAll().addClass( 'step-prev' );
		if( m_currentStep == '1' )
		{
			$( '.step[data-step]:not(.step-current)' ).removeClass( 'step-prev' );
		}
		if( m_currentStep == '2' )
		{
			// If any of the step 2 options are not selected, disable Next button.
			if( m_mainDuration < 0 ||
				( m_mainQty < m_mainQtyMin || m_mainQty > m_mainQtyMax ) ||
				( $( '[name="supportType"]' ).length > 0 && $( '[name="supportType"]:checked' ).length == 0 ) )
			{
				// DEBUG console.log( "disableButton(2) because not all options selected." );
				disableButton( 2 );
			}
			else
			{
				enableButton( 2 );
			}
		}

		if( m_currentStep == '3' )
		{
			// Only MD NEW has step 3. Show feature cross-sells.
			$( '.page-title' ).text( 'Frequently bought together' );
			$( '.payment-icons' ).addClass( 'show-icons' );
		}
		else
		{
			// No cross-sells. Show purchase.
			$( '.page-title' ).text( 'Purchase' );
			$( '.payment-icons' ).removeClass( 'show-icons' );
		}

		// Scroll to top.
		$( window ).scrollTop( 0 );
	} ); // End Set step on click.	

	// This is for styling of the top links. When a selection is made on a step, that's step's top link changes color.
	$( document ).on( 'change', '.purchase-details-info input[type="radio"],.purchase-details-info input[type="checkbox"]', function()
	{
		let activeStep = $( this ).parents( '.purchase-details-info' ).data( 'step' );
		$( '.step-current[data-step="' + activeStep + '"]' ).addClass( 'active' );
	} );

	// Selection change events ****************

	// License Type onChange
	$( document ).on( 'change', 'input[name="licenseType"]', function()
	{
		let thisVal = $( 'input[name = "licenseType"]:checked' ).val();
		let ele = $( this );
		// DEBUG console.log( 'licenseType change event. m_skuType = ' + m_skuType + ', this.val()=' + $( this ).val() + ', thisVal=' + thisVal );
		if( m_skuType == thisVal )
		{
			// Nothing changed.
			return;
		}
		else
		{
			// Reset any values they may have set (and got here via previous button).
			m_mainQty = -1;
		}

		m_skuType = thisVal;
		m_dirty = true;

		clearErrors();

		// Show license type text in "Your Order" box.
		$( '.text-subscription' ).text( getDataLabel( ele ) ).show();

		licenseTypeChanged();

		// As the sku type has changed, throw to the key field and see what needs to be done next.
		$( '.input-product-key' ).focus().trigger( 'keyup' );

	} ); // End License Type onChange

	// In order to get pasted value, you have to wait a tick.
	$( document ).on( 'paste', '.input-product-key', function()
	{
		setTimeout( function()
		{
			$( '.input-product-key' ).trigger( 'keyup' );
		}, 100 );
	} );

	// Old Key keyUp
	$( document ).on( 'keyup', '.input-product-key', function( event )
	{
		if( event.ctrlKey || event.key == "Control" )
		{
			// ctrl-v paste can cause this to trigger twice.
			return;
		}
		if( m_dirty )
		{
			// We probably got here from a change to the sku type, so start fresh.
			m_oldKey = "";
		}
		let ele = $( this )
		if( m_skuType == "NEW" && ele.val() == "" )
		{
			// NEW with no key. Good to go.
			m_oldKey = "";
			m_dirty = true;
			getPrice();
			return;
		}
		// Else, we've got work to do.
		// Don't disable button. Handle elsewhere. - TL, 2025-11-21
		// disableButton( 1 );
		if( ele.val().length < 23 )
		{
			// Not a key... yet.
			disableButton( 1 );
			return;
		}
		if( m_oldKey == ele.val() )
		{
			// We've already looked up that key.
			if( $( '.block-purchase-key' ).find( '.input-error' ).text() == "" )
			{
				// No errors. Enable next button.
				enableButton( 1 );
			}
			return;
		}
		// else
		m_oldKey = ele.val();
		lookupKey();
	} ); // End Old Key keyUp

	// Support onChange
	$( document ).on( 'change', '[name="supportType"]', function()
	{
		// We don't actually use MA because bundles removed. But, we just need something to get the selection value.
		// DEBUG console.log( $( '[name="supportType"]:checked' ).attr( 'data-supportcode' ) );
		m_PrioritySupport = ( $( '[name="supportType"]:checked' ).attr( 'data-supportcode' ) == "MA" );
		m_dirty = true;
		getPrice();
	} );

	// Duration onChange
	$( document ).on( 'change', '[name="licenseTerm"]', function()
	{
		// Has to be this way to get the selected value. (this) != (input[].checked)
		m_mainDuration = $( 'input[name="licenseTerm"]:checked' ).val();
		m_dirty = true;
		getPrice();
	} );

	// Main Qty onChange
	$( document ).on( 'keyup paste', '.input-user-license', function()
	{
		let ele = $( this );

		if( ele.attr( 'readonly' ) != 'readonly' )
		{
			// For straight renewal, size is readonly. In that case, don't disable next.
			disableButton( 2 );
		}
		if( ele.val() < m_mainQtyMin || ele.val() > m_mainQtyMax )
		{
			$( '.block-user-count' ).find( '.input-info' ).addClass( 'error' );
			return;
		}
		if( ele.val() != m_mainQty )
		{
			$( '.block-user-count' ).find( '.input-info' ).removeClass( 'error' );
			m_mainQty = ele.val();
			m_dirty = true;
			getPrice();
		}
	} ); // End Main Qty onChange

	// License Note onChange
	$( document ).on( 'keyup paste', '.input-license-note', function()
	{
		// DEBUG console.log( 'Set license note: ' + $( this ).val() );
		m_mainLicenseNote = $( this ).val();
		// Main product is always last in the array.
		m_allProductsArray[m_allProductsArray.length - 1].properties["user_data"] = m_mainLicenseNote;
	} ); // End License Note onChange


	// Feature selected (checkbox onChange). Toggle options visiblity.
	$( document ).on( 'change', '[name="featureProduct"]', function()
	{
		$( this ).parents( 'li' ).find( '.check-feature-info' ).slideToggle();
		m_dirty = true;
		getPrice();
	} );

	// Feature qty changed (textbox onKeyUp/Paste).
	$( document ).on( 'keyup paste', '[name="addonUser"]', function()
	{
		disableButton( 3 );
		let ele = $( this );
		let min = parseInt( ele.attr( 'min' ) );
		let max = parseInt( ele.attr( 'max' ) );
		let value = parseInt( ele.val() );
		// DEBUG console.log( "Feature qty=" + value + " min=" + min + " max=" + max );
		if( value < min || value > max )
		{
			ele.parents( '.feature-prod-user' ).find( '.input-info' ).addClass( 'error' );
		}
		else
		{
			ele.parents( '.feature-prod-user' ).find( '.input-info' ).removeClass( 'error' );
			m_dirty = true;
			getPrice();
		}
	} );

	// Checkout events ************************

	// Add to cart (for products with no cross sells)
	$( '.purchase-details-info[data-step="2"] .btn-next' ).click( function()
	{
		let btnPreCheckout = $( this ).data( 'buttontype' );
		if( btnPreCheckout == 'precheckout' )
		{
			// m_allProductsArray is populated by getPrice()
			if( m_allProductsArray.length > 0 )
			{
				addToCart( btnPreCheckout );
			}
			// Else, no items, so do nothing. Should not happen.
		}
	} ); // End Pre-Checkout

	// Checkout
	$( '.btn-checkout' ).click( function( e )
	{
		// LEGACY: No idea what this is all about.
		$( '[name="featureProduct"]' ).prop( 'checked', false );
		if( m_allProductsArray.length > 0 )
		{
			e.preventDefault();
			var checkBtn = 'checkout'
			$( '.skip-link' ).remove();
			$( '.skip-anchor' ).show();

			addToCart( checkBtn );
		}
		// Else, no items, so do nothing. Should not happen.
	} ); // End Checkout
} ); // End Document.ready

// Methods *********************************************************************

function licenseTypeChanged()
{
	// If they change license type, all previous values need to be reset.
	$( '.text-your-price' ).html( '' );
	$( '.text-feature-product' ).remove();
	clearErrors();
	$( '.input-user-license' ).val( '' ).removeAttr( 'readonly' ).removeAttr( 'min' ).removeAttr( 'max' );
	//console.log( 'readonly=' + $( '.block-user-count' ).find( '.input-user-license' ).attributes['readonly'].value );
	// Leave addons alone. They are only displayed on NEW anyway. $( '.input-addon-user' ).val( '' ).removeAttr( 'readonly' ).removeAttr( 'min' ).removeAttr( 'max' );

	if( m_skuType == "NEW" )
	{
		if( m_mainProductCode == "MD" || m_mainProductCode == "SG" )
		{
			// Set key field text.
			$( '.text-old-key span' ).text( 'Convert your trial key to a purchased key (recommended)' );
			// TODO: Pull tool tips from tooltipster
			$( '.text-old-key i' ).attr( 'title', 'Easily convert your existing trial key to a purchased key for the life of the software product. If you choose not to provide a trial key, a new key will be issued and must be manually input for use beyond the end of the trial period.' );

			if( m_mainProductCode == "MD" )
			{
				// Cross-sells are for MD NEW only.
				$( '#purchase-steps' ).find( '[data-step="3"]' ).show();
				$( '.action-container' ).find( '.btn-precheckout[data-step="2"]' ).hide();
				$( '.action-container' ).find( '[data-step="3"]' ).show();
			}
		}
		else if( m_mainProductCode == "MS" )
		{
			// No trial key convertions for MailStore
			$( '.input-product-key' ).val( '' );
			$( '.block-purchase-key' ).hide();
		}
		else
		{
			// Set key field text.
			$( '.text-old-key span' ).text( 'Enter your MDaemon key or convert your trial key to a purchased key (recommended)' );
			// TODO: Pull tool tips from tooltipster
			$( '.text-old-key i' ).attr( 'title', 'If you are running MDaemon 18.5 or higher, you can add featured products to your existing MDaemon license. OR convert your existing trial key to a purchased key for the life of the software product. If you choose not to provide a trial key, a new key will be issued and must be manually input for use beyond the end of the trial period.' );
		}
	}
	else
	{
		// Cross-sells are for MD NEW only.
		$( '#purchase-steps' ).find( '[data-step="3"]' ).hide();
		$( '.action-container' ).find( '[data-step="3"]' ).hide();
		$( '.action-container' ).find( '.btn-precheckout[data-step="2"]' ).show();

		$( '.text-old-key span' ).text( 'Please provide your existing registration key' );

		if( m_mainProductCode == "MD" || m_mainProductCode == "SG" )
		{
			// Set key field text.
			// TODO: Pull tool tips from tooltipster
			$( '.text-old-key i' ).attr( 'title', 'Please provide your existing registration key to apply changes.' );
		}
		else if( m_mainProductCode == "MS" )
		{
			$( '.text-old-key span' ).text( 'Please provide your existing MailStore key' );
			// TODO: Pull tool tips from tooltipster
			$( '.block-purchase-key' ).show();
		}
		else
		{
			// Set key field text.
			// TODO: Pull tool tips from tooltipster
			$( '.text-old-key i' ).attr( 'title', 'Please provide your existing registration key to apply changes. If you are running MDaemon 18.5 or higher, this may be your MDaemon key.' );
		}
	}
	if( m_skuType == "UPG" )
	{
		// Hide duration for straight upgrade.
		$( '.block-license-term' ).hide();
		m_mainDuration = 0;
	}
	else if( $( '[name="licenseTerm"]' ).length > 0 )
	{
		// Show duration
		$( '.block-license-term' ).show();
		m_mainDuration = -1;
	}
	checkSupportOptions();
} // End licenseTypeChanged()

function checkSupportOptions()
{
	if( $( '.block-support-type' ).length )
	{
		if( m_oldSAEndDate != "" && !m_oldSAExpired && m_skuType.indexOf( "UPG" ) > -1 )
		{
			// When upgrading a key with an existing SA, force SA selection.
			m_PrioritySupport = true;
			$( '[data-supportcode="MA"]' ).prop( 'checked', true );
			$( '[name="supportType"]' ).attr( 'disabled', 'disabled' );
			$( '.block-support-type' ).find( '.input-error' ).text( "Upgrade of your existing support agreement is required." ).show();
		}
		else
		{
			$( '[name="supportType"]' ).removeAttr( 'disabled' );
			$( '.block-support-type' ).find( '.input-error' ).text( '' ).hide();
		}
	}
} // End checkSupportOptions()

function lookupKey()
{
	m_dirty = true;

	if( m_oldKey == "" )
	{
		// We already handled blank and NEW above. Key is required. Display message.
		clearErrors();
		$( '.block-purchase-key' ).find( '.input-error' ).text( 'Existing Registration Key is required for this license type.' );
		// DEBUG console.log( "disableButton because reg key is required." );
		disableButton( 1 );
		return;
	}
	else
	{
		// Call API.
		m_dirty = true;
		m_mainSku = buildSKU( m_mainProductCode, m_mainDuration );
		let data = { key: m_oldKey, sku: m_mainSku, token: m_token };
		// This was a time saver, but it's causing problems with button enable/disable. - TL, 2025-11-21
		/*
		if( JSON.stringify( data ) == JSON.stringify( m_lastCallData ) )
		{
			// Deja Vu. Do nothing. Don't clear errors. Don't enable button.
			// DEBUG console.log( "Equal. data = " + JSON.stringify( data ) + ", m_lastCallData = " + JSON.stringify( m_lastCallData ) );
			checkSupportOptions();
		}
		else
		*/
		{
			// Ok. NOW clear errors, set buttons.
			clearErrors();
			// DEBUG console.log( "disableButton(1). Calling API" );
			loadingButton( 1 );
			disableButton( 1 );

			// DEBUG console.log( "Not equal. data = " + JSON.stringify( data ) + ", m_lastCallData = " + JSON.stringify( m_lastCallData ) );
			m_lastCallData = data;

			m_oldQty = -1;
			m_oldEndDate = "";
			m_oldSAEndDate = "";
			m_IsFeature = false;

			$( '.block-purchase-key' ).find( '.input-info' ).text( '' ).hide();
			$( '.block-user-count' ).find( '.input-info' ).hide();
			$( '.block-user-count' ).find( '.input-user-license' ).val( '' ).removeAttr( 'readonly' ).removeAttr( 'min' ).removeAttr( 'max' );

			// DEBUG console.log( "AJAX LookUpRegKey, data:" + JSON.stringify( data ) );
			$.ajax( {
				url: 'https://shop.mdaemon.com/Product/LookUpRegKey',
				method: 'POST', type: 'POST',
				data: JSON.stringify( data ),
				dataType: 'json',
				contentType: 'application/json',
				crossDomain: true,
				success: function( result )
				{
					if( result != null )
					{
						// DEBUG console.log( "result:" + JSON.stringify( result ) );
						if( result.ErrorMessage )
						{
							if( result.ErrorMessage == "Invalid request." )
							{
								alert( "An error occurred while looking up your key. Please refresh your browser and try again." );
								return;
							}
							$( '.block-purchase-key' ).find( '.input-error' ).text( 'Please enter your existing registration key. ' + result.ErrorMessage ).show();
							unloadingButton( 1 );
							return;
						}

						let keyInfo = "Your ";
						if( result.ProductSize )
						{
							m_oldQty = result.ProductSize;
							keyInfo += m_oldQty + " user license ";
						}
						else
						{
							// Shouldn't happen.
							keyInfo += "license ";
							m_oldQty = null;
						}
						if( result.EndDate )
						{
							m_oldEndDate = result.EndDate;
							let expire = "expires";
							if( result.KeyExpired )
							{
								expire = "expired";
								m_skuType = m_skuType.replace( "REN", "EXP" );

								if( m_mainProductCode == "MS" )
								{
									// Hide duration for MS_EXP.
									console.log( "MS key expired. Hide term." );
									$( '.block-license-term' ).hide();
									m_mainDuration = 1;
								}
							}
							keyInfo += expire + " on " + m_oldEndDate + ".";
						}
						else
						{
							// Shouldn't happen.
							keyInfo += "is valid.";
							m_oldEndDate = "";
						}
						if( result.SAEndDate )
						{
							m_oldSAEndDate = result.SAEndDate;
							m_oldSAExpired = result.SAExpired;
							keyInfo += " Your Technical Support Agreement " + ( ( m_oldSAExpired ) ? "expired" : "expires" ) + " on " + m_oldSAEndDate + ".";
						}
						else
						{
							m_oldSAEndDate = "";
						}
						if( result.Sku.startsWith( "SA" ) )
						{
							// Special case. SA result includes a forced SKU.
							m_mainSku = result.Sku;
							m_skuType = result.Sku.substr( 3, 3 );
						}
						$( '.block-purchase-key' ).find( '.input-info' ).text( keyInfo ).show();
						if( result.KeyExpired && m_skuType == "UPG" )
						{
							$( '.block-purchase-key' ).find( '.input-error' ).text( 'Your registration key is expired and must be renewed in order to upgrade.' ).show();
							unloadingButton( 1 );
							disableButton( 1 );
							return;
						}
						if( result.MinQty && result.MaxQty )
						{
							m_mainQtyMin = parseInt( result.MinQty );
							m_mainQtyMax = parseInt( result.MaxQty );

							if( m_mainQtyMin == m_mainQtyMax )
							{
								m_mainQty = m_mainQtyMin;
								$( '.block-user-count' ).find( '.input-user-license' ).val( m_mainQtyMin ).attr( 'readonly', 'readonly' );
								$( '.block-user-count' ).find( '.input-info' ).text( '' ).hide();
							}
							else
							{
								$( '.block-user-count' ).find( '.input-user-license' ).attr( 'min', m_mainQtyMin ).attr( 'max', m_mainQtyMax ).removeAttr( 'readonly' );
								$( '.block-user-count' ).find( '.input-info' ).text( 'Choose between ' + m_mainQtyMin + ' and ' + m_mainQtyMax + ' users.' ).show();
							}
						}
						else
						{
							// Shoudnl't happen.
							m_mainQtyMin = m_mainQtyMin = null;
						}
						// DEBUG console.log( "Successful key lookup." );
						checkSupportOptions();
						getPrice();
						unloadingButton( 1 );
						enableButton( 1 );
						return;
					}
					else
					{
						// TODO: Handle key lookup failed to return.
						console.log( "lookupKey API returned null" ); //DEBUG
						$( '.block-purchase-key' ).find( '.input-error' ).text( 'Please enter your existing registration key or contact customer support.' ).show();
						unloadingButton( 1 );
					}
				},
				error: function( err )
				{
					// TODO: Handle key lookup errors.
					console.log( "lookupKey API returned error: " + JSON.stringify( err ) ); // DEBUG
					$( '.block-purchase-key' ).find( '.input-error' ).text( 'Please enter your existing registration key or contact customer support. ' +
						err.responseText ).show();
					unloadingButton( 1 );
				}
			} );
		}
	}
} // End lookupKey()

function getPrice()
{
	// Start fresh. We'll populate this below.
	m_allProductsArray = [];
	if( !m_dirty || m_skuType == "" || m_mainDuration < 0 ||
		( m_skuType != "NEW" && m_oldKey == "" ) ||
		( m_mainQty < m_mainQtyMin || m_mainQty > m_mainQtyMax ) ||
		( $( '[name="supportType"]' ).length > 0 && $( '[name="supportType"]:checked' ).length == 0 ) )
	{
		// Either nothing changed, or we don't have enough data to get a price.
		/* DEBUG var debug1 = ( $( '[name="supportType"]' ).length > 0 && $( '[name="supportType"]:checked' ).length == 0 );
		console.log( "getPrice bailed out: m_dirty=" + m_dirty
			+ " m_mainProductCode=" + m_mainProductCode
			+ " m_skuType=" + m_skuType
			+ " m_mainDuration=" + m_mainDuration
			+ " m_oldKey=" + m_oldKey
			+ " m_mainQty=" + m_mainQty
			+ " supportType selection=" + debug1
		); */
		return;
	}

	$( '.total-money' ).text( 'Calculating...' );

	m_mainSku = buildSKU( m_mainProductCode, m_mainDuration );

	// Add cross-sells
	let featuresArray = [];
	let featuresGood = true;
	if( $( '[name="featureProduct"]' ).length > 0 )
	{
		$( '[name="featureProduct"]:checked' ).each( function()
		{
			let parentLi = $( this ).parents( '.item-feature' );
			let productCode = parentLi.attr( 'data-productcode' );
			let inputEle = parentLi.find( '[name="addonUser"]' );
			let qty = -1;
			let min = -1;
			let max = -1;

			// AV shares MD's qty.
			if( productCode == "AV" )
			{
				qty = m_mainQty;
			}
			else
			{
				// No qty selected. Bail.
				if( inputEle.val() == '' )
				{
					// DEBUG console.log( "Disable button. getPrice bailed out: " + productCode + " has no qty." );
					disableButton( m_currentStep );
					featuresGood = false;
					return;
				}
				// This should not be necessary if it's caught correctly earlier, but....
				qty = parseInt( inputEle.val() );
				min = parseInt( inputEle.attr( 'min' ) );
				max = parseInt( inputEle.attr( 'max' ) );
				if( qty < min || qty > max )
				{
					// DEBUG console.log( "Disable button. getPrice bailed out: " + productCode + " has invalid qty." );
					disableButton( m_currentStep );
					featuresGood = false;
					return;
				}
			}
			// Only MS has a duration.
			let duration = -1;
			if( productCode == "MS" )
			{
				duration = parseInt( parent.find( '[name="addonTerm"]:checked' ).val() );
			}
			else
			{
				duration = m_mainDuration;
			}
			let sku = buildSKU( productCode, duration );
			featuresArray.push( { 'ProductCode': productCode, 'SKU': sku, 'NewQty': qty } );
		} );
		if( !featuresGood )
		{
			return;
		}
	}

	let newQty = m_mainQty;
	if( m_oldQty > 0 )
	{
		newQty -= m_oldQty;
	}

	// Call API.
	let requestData = {
		Products: [{
			ProductCode: m_mainProductCode,
			SKU: m_mainSku,
			NewQty: newQty,
			OldKey: m_oldKey,
			IncludeSupport: m_PrioritySupport,
			FeaturesArr: featuresArray
		}],
		UserId: m_userID,
		Token: m_token
	};

	// TODO: Use a global variable to prevent mulitple calls with the same request data. (Especially happens here due to ctrl-V keyup events.)
	// {"sku":"MD_NEW_P1","newQty":"8","oldKey":"","featuresArr":[{"sku":"AV_NEW_P1","qty":"8"},{"sku":"OC_NEW_P1","qty":6}],"userId":""}
	// DEBUG console.log( "AJAX GetUnitPrice, requestData:" + JSON.stringify( requestData ) );
	loadingButton( m_currentStep );
	$.ajax( {
		url: 'https://shop.mdaemon.com/Product/GetUnitPrice',
		method: 'POST', type: 'POST',
		data: JSON.stringify( requestData ),
		dataType: 'json',
		contentType: 'application/json',
		crossDomain: true,
		success: function( result )
		{
			if( result != null )
			{
				// DEBUG console.log( "result:" + JSON.stringify( result ) );
				if( result.ErrorMessage )
				{
					if( result.ErrorMessage == "Invalid request." )
					{
						alert( "An error occurred while looking up your key. Please refresh your browser and try again." );
						return;
					}
					$( '.action-container' ).find( '.input-error' ).text( 'Error getting price. ' + result.ErrorMessage ).show();
					unloadingButton( 1 );
					return;
				}
				if( !result.Products || result.Products.length == 0 )
				{
					// Should not happen.
					$( '.action-container' ).find( '.input-error' ).text( "Error getting price.." );
					// Don't enable after an error. - TL, 2025-11-21
					// enableButton( m_currentStep );
					return;
				}

				if( m_mainProductCode != "SA" )
				{
					// To avoid asynch collisions, make sure the result qty matches the current value.
					var latestQty = $( '.input-user-license' ).val();
					if( m_oldQty > 0 )
					{
						latestQty -= m_oldQty;
					}
					if( latestQty != result.Products[0].NewQty )
					{
						return;
					}
					// Also for features.
					if( result.Products[0].FeaturesArr && result.Products[0].FeaturesArr.length > 0 )
					{
						result.Products[0].FeaturesArr.forEach( function( feature )
						{
							var latestFeatureQty = $( '[data-productcode=' + feature.ProductCode + '] .input-addon-user' ).val();
							if( latestFeatureQty != feature.NewQty )
							{
								return;
							}
						} );
					}
				}
				else
				{
					// For SA, to avoid asynch collisions, make sure the result key matches the current key.
					var latestKey = $( 'input-product-key' ).val();
					if( result.OldKey != latestKey )
					{
						return;
					}
				}

				let errors = "";
				if( result.ErrorMessage && result.ErrorMessage != "OK" )
				{
					// TODO: Is this safe to display?
					errors += result.ErrorMessage + " ";
				}
				if( result.Products[0].ErrorMessage )
				{
					errors += result.Products[0].ErrorMessage + " ";
				}
				if( result.Products[0].FeaturesArr && result.Products[0].FeaturesArr.length > 0 )
				{
					result.Products[0].FeaturesArr.forEach( function( feature )
					{
						if( feature.ErrorMessage )
						{
							// TODO: Is this safe to display?
							errors += feature.ErrorMessage + " ";
						}
					} );
				}
				if( errors.length > 0 )
				{
					$( '.action-container' ).find( '.input-error' ).text( "Error getting price. " + errors ).show();
					unloadingButton( m_currentStep );
					disableButton( m_currentStep );
					return;
				}
				else
				{
					clearErrors();
				}

				m_totalPrice = 0;
				m_mainDescription = result.Products[0].Description;
				m_mainListPrice = parseInt( parseFloat( result.Products[0].ListPrice ) * 100 );
				m_mainDiscountPrice = parseInt( parseFloat( result.Products[0].DiscountPrice ) * 100 );
				m_SAPrice = parseInt( parseFloat( result.Products[0].SAPrice ) * 100 );
				let newEndDate = ( result.Products[0].NewEndDate != "" ) ? new Date( result.Products[0].NewEndDate ) : null;
				let newSAEndDate = ( result.Products[0].NewSAEndDate != "" ) ? new Date( result.Products[0].NewSAEndDate ) : null;
				let yourPriceText = m_mainDescription;
				if( m_mainListPrice > m_mainDiscountPrice )
				{
					m_totalPrice += m_mainDiscountPrice;
					yourPriceText += ': <del class="discounted-price">$' + ( m_mainListPrice / 100 ).toFixed( 2 ) + '</del> $' + ( m_mainDiscountPrice / 100 ).toFixed( 2 );
				}
				else
				{
					m_totalPrice += m_mainListPrice;
					yourPriceText += ": $" + ( m_mainListPrice / 100 ).toFixed( 2 );
				}
				if( newEndDate != null )
				{
					yourPriceText += "<br />Your new license will expire on " + newEndDate.toLocaleDateString() + ".";
				}
				$( '.text-your-price' ).html( yourPriceText ).show();

				let mainProductObj = {
					quantity: 1,
					id: m_mainProductID,
					properties: {
						// cart will set _item_index.
						'description': m_mainDescription,
						'old_key': m_oldKey,
						'user_data': m_mainLicenseNote,
						'_sku': result.Products[0].SKU,
						'_product_code': m_mainProductCode,
						'_product_id': m_mainProductID,
						'_user_count': result.Products[0].NewQty,
						'_final_qty': result.Products[0].FinalQty,
						'_license_term': result.Products[0].Duration,
						'_list_price': m_mainListPrice,
						'_discount_price': m_mainDiscountPrice,
						'_is_md_feature': false
					}
				};

				// unshift rather than push. Shopify pushes line items, so last item in is index zero, which screws up single installer features.
				m_allProductsArray.unshift( mainProductObj );
				$( '.text-feature-product' ).remove();

				// Get support prices (MD only).
				if( m_PrioritySupport && m_SAPrice > 0 )
				{
					m_totalPrice += m_SAPrice;
					let supportProductDescription = result.Products[0].SADescription;
					let supportElement = '<p id="MDaemon-Support" class="text-feature-product">' + supportProductDescription + ': $' + ( m_SAPrice / 100 ).toFixed( 2 );
					if( newSAEndDate != null )
					{
						supportElement += "<br />Your support agreement will expire on " + newSAEndDate.toLocaleDateString() + ".";
					}
					supportElement += '</p>';
					$( '.center-cart-info' ).append( supportElement );

					let supportObj = {
						quantity: 1,
						id: 4637503291428,
						properties: {
							'description': supportProductDescription,
							'old_key': m_oldKey,
							'_sku': result.Products[0].SASKU,
							'_product_code': "SA",
							'_product_id': 4637503291428,
							'_user_count': result.Products[0].NewQty,
							'_final_qty': result.Products[0].FinalQty,
							'_license_term': result.Products[0].Duration,
							'_list_price': m_SAPrice,
							'_discount_price': m_SAPrice,
							'_is_md_feature': true
						}
					};
					m_allProductsArray.unshift( supportObj );
				}

				// Get feature prices (MD NEW only).
				if( result.Products[0].FeaturesArr )
				{
					result.Products[0].FeaturesArr.forEach( function( feature, index )
					{
						let featureProductCode = feature.ProductCode;
						let featureNewQty = feature.NewQty;
						let featureListPrice = parseInt( parseFloat( feature.ListPrice ) * 100 );
						let featureDiscountPrice = parseInt( parseFloat( feature.DiscountPrice ) * 100 );

						let parentLi = $( '[data-productcode=' + featureProductCode + ']' );

						let featureProductName = parentLi.data( 'productname' );
						let featureProdId = parseFloat( parentLi.data( 'feature-id' ) );

						let featurePriceText = "";
						if( featureListPrice > featureDiscountPrice )
						{
							m_totalPrice += featureDiscountPrice;
							featurePriceText = '<del class="discounted-price">$' + ( featureListPrice / 100 ).toFixed( 2 ) + '</del> $' + ( featureDiscountPrice / 100 ).toFixed( 2 );
						}
						else
						{
							m_totalPrice += featureListPrice;
							featurePriceText = '$' + ( featureListPrice / 100 ).toFixed( 2 );
						}
						// I don't think exists. $( parentLi ).find( 'feature-prod-price' ).html( featurePriceText ).show();
						// TODO: Can we use product code instead of product name for the feature element ID in the price summary??
						let featureElement = '<p id="' + featureProductName.replace( ' ', '-' ) + '" class="text-feature-product">' + feature.Description + ': ' + featurePriceText + '</p >';
						$( '.center-cart-info' ).append( featureElement );

						let addOnObj = {
							quantity: 1,
							id: featureProdId,
							properties: {
								'description': feature.Description,
								'_sku': feature.SKU,
								'_product_code': featureProductCode,
								'_product_id': featureProdId,
								'_user_count': featureNewQty,
								'_final_qty': featureNewQty,
								'_license_term': feature.Duration,
								'_list_price': featureListPrice,
								'_discount_price': featureDiscountPrice,
								'_is_md_feature': true
							}
						};
						// Push in reverse order because cart puts last in first.
						m_allProductsArray.unshift( addOnObj );
					} );
				}
				/* DEBUG
				else { console.log( "FeatureArray empty? " + result.Products[0].FeaturesArr ); }
				*/

				$( '.total-money' ).text( '$' + ( m_totalPrice / 100 ).toFixed( 2 ) );
				// DEBUG console.log( "enableButton. GetUnitPrice success." );
				enableButton( m_currentStep );
				m_dirty = false;
			}
			else
			{
				console.log( "getPrice API returned null" ); //DEBUG
				$( '.action-container' ).find( '.input-error' ).text( "Error getting price." );
				// Don't enable after an error. - TL, 2025-11-21
				// enableButton( m_currentStep );
			}
			// DEBUG console.log( "getPrice done. products: " + JSON.stringify( m_allProductsArray ) );
		},
		error: function( err )
		{
			let errorMessage = "Error getting price. ";
			if( err != null && err.length > 0 )
			{
				console.log( "Error in response: " + JSON.stringify( err ) ); // DEBUG
				// TODO: Is this safe to display? Better error message?
				errorMessage += err.responseText;
			}
			else
			{
				console.log( "Error in response but nothing returned." ); // DEBUG
				errorMessage += "A server error occurred.";
			}
			$( '.action-container' ).find( '.input-error' ).text( errorMessage );
			// Don't enable after an error. - TL, 2025-11-21
			// enableButton( m_currentStep );
		}
	} );
} // End getPrice()

function addToCart( checkBtn )
{
	// DEBUG console.log( "addToCartProducts" ); items: " + JSON.stringify( m_allProductsArray ) )
	$( '.checkout-error' ).text( '' ).hide();
	// LEGACY: disabling buttons on addToCart???
	$( '.btn-step' ).css( 'pointer-events', 'none' );
	$( '.btn-form' ).attr( 'disabled', 'disabled' );
	$( '.btn-' + checkBtn ).addClass( 'btn-loading' );
	var newArray = [];

	for( let i = 0; i < m_allProductsArray.length; i++ )
	{
		let item = m_allProductsArray[i];
		let productCode = item.properties._product_code;
		let sku = item.properties._sku;
		let usercount = parseInt( item.properties._user_count );
		let finalQty = parseInt( item.properties._final_qty );
		let duration = parseInt( item.properties._license_term );
		let price = parseInt( item.properties._discount_price );
		var newData = { "ProductId": item.id, "ProductCode": productCode, "Sku": sku, "Price": price / 100, "UserCount": usercount, "FinalQty": finalQty, "Duration": duration };
		newArray.push( newData );
	}
	let variantData = '{"Variants":' + JSON.stringify( newArray ) + ', "token":"' + m_token + '"}';

	// Call API to get custome variant IDs.
	try
	{
		// DEBUG console.log( "Ajax CustomVariant, variantData=" + variantData )
		$.ajax( {
			url: "https://shop.mdaemon.com/Product/CustomVariant",
			data: variantData,
			method: 'POST', type: 'POST',
			dataType: 'json',
			contentType: 'application/json',
			crossDomain: true,
			success: function( result )
			{
				if( result.ErrorMessage == "Invalid request." )
				{
					alert( "An error occurred while building your cart. Please refresh your browser and try again." );
					return;
				}
				else if( result.ErrorMessage && result.ErrorMessage.length > 0 )
				{
					// TODO: Safe to display?
					alert( result.ErrorMessage );
					return;
				}
				// Refactored because I can't figure out why error is firing on successful result. - TL 2021-05-25
				// DEBUG console.log( 'CustomVariant success.' );
				CVSuccess( result, checkBtn );
			},
			error: function( err )
			{
				if( err != null && err.responseText.length > 0 && JSON.parse( err.responseText ).Variants != null )
				{
					// TODO: When new variant is created error result always fires, even though responseText contains successful result.
					// DEBUG console.log( 'CustomVariant error, but still success.' );
					CVSuccess( JSON.parse( err.responseText ), checkBtn );
				}
				else
				{
					if( err != null && err.length > 0 )
					{
						console.log( "Error in response: " + JSON.stringify( err ) ); // DEBUG
					}
					else
					{
						console.log( "Error in response but nothing returned. " ); // DEBUG
					}
					$( '.checkout-error' ).text( "Error adding to cart. Please try again." ).show();
					enableButton( m_currentStep );
				}
			}
		} );
	}
	catch( err )
	{
		console.log( "Error in addToCart(). " ); // DEBUG
		if( err != null && err.message != null )
		{
			console.log( err.message ); // DEBUG
		}
		$( '.checkout-error' ).text( "Error adding to cart. Please try again." ).show();
		enableButton( m_currentStep );
	}
} // End addToCart()

// Refactored because I can't figure out why error is firing on successful result. - TL 2021-05-25
function CVSuccess( result, checkBtn )
{
	if( result != null )
	{
		// DEBUG console.log( "result:" + JSON.stringify( result ) );
		for( let i = 0; i < result.Variants.length; i++ )
		{
			m_allProductsArray[i].id = result.Variants[i].VariantID;
			m_allProductsArray[i].properties["_variant_title"] = result.Variants[i].VariantTitle;
		}
		var pro = setInterval( function()
		{
			$.ajax( {
				url: '/cart/add.js',
				type: "post",
				data: { items: m_allProductsArray },
				dataType: 'json',
				success: function( data )
				{
					console.log( 'Success.' );
					$( '.btn-' + checkBtn ).removeClass( 'btn-loading' );
					location.href = "/cart";
				},
				error: function( err )
				{
					console.log( "Failed to add items. " + JSON.stringify( err ) ); // DEBUG
					$( '.checkout-error' ).text( "Error adding to cart. Please try again." ).show();
					enableButton( m_currentStep );
				}
			} )
			clearInterval( pro );
		}, 100 );
	}
	else
	{
		console.log( "CVSuccess returned null" ); // DEBUG
		// TODO: I need a new place to display this error.
		$( '.checkout-error' ).text( "Error adding to cart. Please try again." ).show();
		enableButton( m_currentStep );
	}
} // End CVSuccess()

function buildSKU( productCode, duration )
{
	// Special case for SA purchase. 
	if( m_mainProductCode == "SA" )
	{
		if( !m_skuType )
		{
			// First time in, m_skuType is undefined.
			m_skuType = "NEW";
			return "SA_NEW_P1";
		}
		else
		{
			// lookupKey() set the correct SKU.
			return m_mainSku;
		}
	}

	let sku = productCode + "_" + m_skuType.replace( "/UPG", "" ) + "_P1";
	if( m_skuType.indexOf( "UPG" ) > -1 )
	{
		sku += "_P1";
	}
	if( duration > 1 )
	{
		sku += "_" + duration + "YR";
	}
	// DEBUG console.log( "buildSKU returns " + sku );
	return sku;
} // End buildSKU()

function getDataLabel( ele )
{
	let label = ele.attr( 'data-label' );
	if( label.indexOf( '(' ) > -1 )
	{
		label = label.split( '. (' )[0];
	}
	return label;
}
function clearErrors()
{
	// Remove any previous error messages.
	$( '.purchase-details-info' ).find( '.input-error' ).text( '' ).hide();
}
function disableButton( step )
{
	// DEBUG console.log( "Disable next button for step " + step );
	$( '.purchase-details-info[data-step="' + step + '"]' ).find( '.btn-next, .btn-checkout' ).attr( 'disabled', 'disabled' );
}
function loadingButton( step )
{
	// DEBUG console.log( "Loading style on next button for step " + step );
	$( '.purchase-details-info[data-step="' + step + '"]' ).find( '.btn-next, .btn-checkout' ).addClass( 'btn-loading' );
}
function unloadingButton( step )
{
	// DEBUG console.log( "Remove loading style from next button for step " + step );
	$( '.purchase-details-info[data-step="' + step + '"]' ).find( '.btn-next, .btn-checkout' ).removeClass( 'btn-loading' );
}
function enableButton( step )
{
	if( step == 2 && ( m_mainDuration == -1 || m_mainQty < m_mainQtyMin || m_mainQty > m_mainQtyMax ) )
	{
		// DEBUG console.log( "step 2, not enough data. Don't enable button." );
		return;
	}
	// DEBUG console.log( "Enable next button for step " + step );
	$( '.purchase-details-info[data-step="' + step + '"]' ).find( '.btn-next, .btn-checkout' ).removeAttr( 'disabled' ).removeClass( 'btn-loading' );
}